export const formatDistance = (kmValue) => {
  const num = Number(kmValue);
  if (isNaN(num) || num < 0) return "0 m";

  const meters = num * 1000;

  if (meters < 1000) {
    return `${meters.toFixed(1)} m`;
  } else {
    return `${(meters / 1000).toFixed(1)} km`;
  }
};
